// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"checkout_sectionHeading__3lXcI","actionBtnContainer":"checkout_actionBtnContainer__266wS","nextBtn":"checkout_nextBtn__20Sb_"};